import { jsx, Fragment } from "react/jsx-runtime";
import { highlightMatches } from "../../../utils/highlightMatches.js";
const highlight = (str, substring) => {
  const offset = str.toLowerCase().indexOf(substring.toLowerCase());
  return offset === -1 ? str : /* @__PURE__ */ jsx(Fragment, { children: highlightMatches(str, [{ length: substring.length, offset }]) });
}, highlightSelected = (children, filter) => typeof children == "string" && filter ? highlight(children, filter) : children;
export {
  highlightSelected
};
//# sourceMappingURL=highlightSelected.js.map
